export const PASSING_GRADE = 5.5;

// Convert a score between 0 and 1 (inclusive) to a color name.
export function getScoreColor(score) {
    if (!Number.isFinite(score) || score < 0 || score > 1) {
        return
    }

    score = Math.round(score * 100)

    if (score < 50) {
        return 'red'
    }

    if (score < 67) {
        return 'orange'
    }

    return 'green'
}

export function getStudentProgressBarFragments(hasVisibleAnswers, hasVariableTaskCount, score, percChecked, progress) {
    if (
        hasVisibleAnswers === false ||
        (!_.isNumber(score) && !_.isNumber(percChecked))
    ) {
        return {
            blue: progress
        }
    }
    if (hasVariableTaskCount) {
        return {
            green: score,
            red: 1 - score,
        }
    }
    return {
        green: progress * percChecked * score,
        red: progress * percChecked * (1 - score),
        gray: progress - progress * percChecked,
    }
}

export function getLastDomainFilter(groupModel) {
    const contentDomainFilterSetting = parseInt(sessionStorage.getItem(
        `${Backbone.Model.user.id}:${groupModel.id}:contentDomainFilter`
    ))
    return groupModel.getContentDomain()?.get('items').find((item) => {
        return item.id === contentDomainFilterSetting
    }) ?? null
}

export function setLastDomainFilter(groupModel, value) {
    if (
        Number.isInteger(value) &&
        groupModel.getContentDomain()?.get('items').some((item) => item.id === value)
    ) {
        sessionStorage.setItem(`${Backbone.Model.user.id}:${groupModel.id}:contentDomainFilter`, value)
    } else {
        sessionStorage.removeItem(`${Backbone.Model.user.id}:${groupModel.id}:contentDomainFilter`)
    }
}

export function setupProgressModelFilters(model, groupModel) {
    const contentDomainFilterSetting = getLastDomainFilter(groupModel)
    if (contentDomainFilterSetting !== null) {
        model.set({contentDomainFilter: contentDomainFilterSetting.id})
    } else {
        model.unset('contentDomainFilter')
    }
    model.on('change:contentDomainFilter', () => {
        setLastDomainFilter(groupModel, model.get('contentDomainFilter'))
    })

    // TODO move to sessionStorage
    const sortingSettings = Backbone.Model.user.getSetting('sortProgressBy')
    if (sortingSettings) {
        const [ sortProgressBy, orderProgressBy ] = sortingSettings.split(':')
        model.set({
            sortProgressBy,
            orderProgressBy,
        })
    }
}
